module.exports = __webpack_public_path__ + "img/crowdin.5f3f155f.png";